import { Component, Vue } from "vue-property-decorator";
import Cookies from 'js-cookie';

import { BlankPage, Loading, Nav, LBlist, LBdetail, LBtable, Hint } from "@/components";
import { Reconciliation, Common, ScheduleReport } from "@/constant";
import { ReimbursementModel, ScheduleReportModel } from "@/models";
import { TCBReceiptApi } from "@/network/pb/proto";

import { UserInfo } from "@/types/Login";

import { Priv } from "@/util/Priv";
import { DefaultPath } from "@/constant/GroupPermission";
import { Util } from "@/util/Util";

// 特店 - 子項目 (每個特店資訊)
type Store = {
    id: number;
    code: string;
    name: string;
    selected: boolean;
};

// 特店 - 主項目 (統編號碼 + 全選)
type StoreGroup = {
    tidNumber: string;
    selected: boolean;
    storeList: Store[];
};

// 列表 - 彙總
type GroupItem = {
    terminalNo: string;
    date: string;
    batchNo: string;
    count: number;
    amount: number;
    infoType: number;
};

@Component<ReconciliationReimbursementController>({
    components: {
        BlankPage,
        Nav,
        Loading,
        LBlist,
        LBdetail,
        LBtable,
        Hint,
    },
})
export default class ReconciliationReimbursementController extends Vue {
    private isLoading = true; // 控制顯示header

    // 搜尋引擎 - 空用元件
    private expireTime = 0;    
    private periodMap = Reconciliation.PeriodMap;
    private transactionMap = Reconciliation.TransactionMap;
    private noteMap = Reconciliation.NoteMap;
    private cardMap = Reconciliation.CardMap;
    private minDate = "";
    private maxDate = "";

    private searchItem: {
        storeType: number;
        tidNumber: string;
        storeArr: string[];
        type: number;
        periodType: number;
        start: string;
        end: string;
        transactionType: number;
        noteType: number;
        cardType: string[];
        cardNum: string;
        orderNum: string;
        machineCodeStart: string;
        machineCodeEnd: string;
        approvalCode: string;
    } = {
            storeType: 0,
            tidNumber: "",
            storeArr: [],
            type: 1, // 結帳請款日區間
            periodType: 1,
            start: "",
            end: "",
            transactionType: 0,
            noteType: 0,
            cardType: ["1", "2", "3", "4", "5"],
            cardNum: "",
            orderNum: "",
            machineCodeStart: "",
            machineCodeEnd: "",
            approvalCode: "",
        };
    private datePeriodStartMax = "";

    private tidNumberArr:string[] = [];

    // 明細 - 取得卡別彙總
    private reimbursementSummary = TCBReceiptApi.Protobuf.ReimbursementSummary.create();

    // 選取特約清單 => 是否展開LB
    private storeGroupList: StoreGroup[] = [];
    private isOpenStoreLB = false;

    // filter => 明細, 依端末機彙總, 依結帳請款日彙總
    private filterType = "date";

    // 列表
    private reconciliationList: TCBReceiptApi.Protobuf.IReconciliation[] = []; // 什麼時候需要加I  (Store => IStore)
    // 自己觀察是如果使用 賦予值=create() 則可以直接使用pb; 如果是先定義型別再初始化的寫法會對應不到pb
    private reimbursementCollectionMap = TCBReceiptApi.Protobuf.ReimbursementCollectionMap.create();
    private reimbursementTotal = TCBReceiptApi.Protobuf.ReimbursementTotal.create();
    // 列表 - 依結帳請款日彙總
    private byGroupDateMap: { [k: string]: GroupItem[] } = {};
    private byGroupDateTableMap: { [k: string]: TCBReceiptApi.Protobuf.ReimbursementInfo[] } = {};
    // 列表 - 依端末機彙總
    private byGroupTerminalMap: { [k: string]: GroupItem[] } = {};
    private byGroupTerminalTableMap: { [k: string]: (TCBReceiptApi.Protobuf.ReimbursementInfo | GroupItem)[] } = {};
    // 列表 - 明細
    private byTerminalNoMap: { [k: string]: TCBReceiptApi.Protobuf.ReimbursementInfo[] } = {};

    // 展開收合
    private isUnfold = false;
    private unfoldList: string[] = [];

    // 展開明細
    private showAllList: string[] = [];

    // 查看明細 => 是否展開LB
    private isOpenDetailLB = false;
    private detailTitle: object = {};
    private detail = TCBReceiptApi.Protobuf.ReimbursementInfo.create();
    private detailType = 1; // 預設 1 => 請款, 2 => 撥款

    // 查看批號明細 => 是否展開LB
    private isOpenTableLB = false;
    private batchNoTitle = TCBReceiptApi.Protobuf.Reconciliation.create();
    private batchNoInfo: object = {};
    private tableType = 1; // 預設 1 => 請款, 2 => 撥款

    // LB
    private hintBox: { show: boolean, msg: string } = { show: false, msg: "" };

    // 屬於該帳號下的統編 => 用來取得特店清單
    private tidNumber = "";

    public async created() {
        /* 取得最新的權限map並判斷有何權限 */
        await this.setPriv();
        /* 取得最新的權限map並判斷有何權限 */

        const userInfo: UserInfo = JSON.parse(Cookies.get("appUserInfo") as string);
        this.tidNumber = userInfo.identification as string;
        console.log(this.tidNumber);

        const day = new Date();
        this.searchItem.end = day.toISOString().split("T")[0];
        this.datePeriodStartMax = day.toISOString().split("T")[0];
        day.setDate(day.getDate() - 1);
        this.searchItem.start = day.toISOString().split("T")[0];

        /* sample data */
        // this.searchItem.start =  "2020-12-21";
        // this.searchItem.end = "2020-12-21";
        /* sample data */

        this.isLoading = false;

        localStorage.removeItem("FrontReconciliationReimbursement");
    }

    /* 選取特店清單LB */
    // 取得特店清單
    private async getStoreList(tidNumber: string) {
        console.log("getStoreList");
        console.log(tidNumber);

        const item = TCBReceiptApi.Protobuf.StoreInsertQuery.create({
            type: TCBReceiptApi.Protobuf.StoreInsertQueryType.SIQT_TID_NUMBER,
            identification: tidNumber,
        });
        console.log("item");
        console.log(item);

        const storeInsertQuery = TCBReceiptApi.Protobuf.StoreInsertQuery.encode(
            item
        ).finish();
        await ReimbursementModel.getStoreSearch(storeInsertQuery);

        /* 取得該帳號下的特店清單 */
        const storeUserPermissionMap = ReimbursementModel.getStoreList().map;
        console.log("StoreUserPermissionMap");
        console.log(storeUserPermissionMap);

        Object.keys(storeUserPermissionMap).forEach(thisTidNumber => {
            const rawSearchList = storeUserPermissionMap[thisTidNumber] as TCBReceiptApi.Protobuf.StoreUserPermissionList;
            // 組成map傳至LB給component使用
            const storeList: Store[] = [];

            rawSearchList.list.forEach((thisStore: any) => {
                const store: Store = {
                    id: thisStore.storeId as number,
                    code: thisStore.storeCode as string,
                    name: thisStore.registerName?.trim() as string,
                    selected: true,//預設全選
                };

                storeList.push(store);
            });

            const storeGroup: StoreGroup = {
                tidNumber: thisTidNumber,
                selected: true,//預設全選
                storeList: storeList,
            };

            this.storeGroupList.push(storeGroup);
        });
        /* 取得該帳號下的特店清單 */
    }

    private closeLBlist() {
        this.isOpenStoreLB = false;
    }

    private selectStore(type: number, tidNumber: string, storeArr: string[], tidNumberArr: string[]) {
        console.log("type");
        console.log(type);
        console.log("tidNumber");
        console.log(tidNumber);
        console.log("storeArr");
        console.log(storeArr);

        this.searchItem.storeType = type;
        this.searchItem.tidNumber = tidNumber;
        this.searchItem.storeArr = storeArr;
        this.tidNumberArr = tidNumberArr;

        this.isOpenStoreLB = false;
    }
    /* 選取特店清單LB */

    /* 起訖日期 */
    private bindDateType() {
        if (String(this.searchItem.periodType) === "2") {
            // 調整日期的起訖
            const day = new Date();
            this.searchItem.end = day.toISOString().split("T")[0];
            day.setDate(day.getDate() - 7);
            this.searchItem.start = day.toISOString().split("T")[0];
            this.datePeriodStartMax = day.toISOString().split("T")[0];
        } else if (String(this.searchItem.periodType) === "3") {
            // 調整日期的起訖
            const day = new Date();
            this.searchItem.end = day.toISOString().split("T")[0];
            day.setDate(day.getDate() - 31);
            this.searchItem.start = day.toISOString().split("T")[0];
            this.datePeriodStartMax = day.toISOString().split("T")[0];
        } else {
            const day = new Date();
            this.datePeriodStartMax = day.toISOString().split("T")[0];
        }
    }

    private bindDatePeriod() {
        if (String(this.searchItem.periodType) === "2") {
            // 調整日期的起訖
            const day = new Date(this.searchItem.start);
            this.searchItem.start = day.toISOString().split("T")[0];
            day.setDate(day.getDate() + 7);
            this.searchItem.end = day.toISOString().split("T")[0];
        } else if (String(this.searchItem.periodType) === "3") {
            // 調整日期的起訖
            const day = new Date(this.searchItem.start);
            this.searchItem.start = day.toISOString().split("T")[0];
            day.setDate(day.getDate() + 31);
            this.searchItem.end = day.toISOString().split("T")[0];
        }

        const day = new Date(this.searchItem.start);

        if (
            new Date(this.searchItem.start).getTime() >
            new Date(this.searchItem.end).getTime()
        ) {
            this.searchItem.end = this.searchItem.start;
        }

        this.minDate = day.toISOString().split("T")[0];
        day.setDate(day.getDate() + 31);
        this.maxDate = day.toISOString().split("T")[0];

        if (
            (new Date(this.searchItem.end).getTime() - new Date(this.searchItem.start).getTime()) >= 86400 * 31 * 1000
        ) {
            this.searchItem.end = day.toISOString().split("T")[0];
        }
    }
    /* 起訖日期 */

    /* LB */
    private openHint(msg: string) {
        this.hintBox.msg = msg;
        this.hintBox.show = true;
    }
    private closeHint() {
        this.hintBox.msg = "";
        this.hintBox.show = false;
    }
    /* LB */

    /* 搜尋 */
    private validCondition(): boolean {
        // 沒有選取特店
        if (this.searchItem.storeType === 0) {
            this.openHint(Common.ErrorCodeMap[Common.ErrorHintMap.RequireStore]);
            return false;
        }

        if (this.searchItem.start === "" || this.searchItem.end === "") {
            this.openHint(Common.ErrorCodeMap[Common.ErrorHintMap.RequireDate]);
            return false;
        }

        // 無法查詢未來時間
        const startUnix = new Date(this.searchItem.start).getTime();
        const endUnix = new Date(this.searchItem.end).getTime();
        const dUnix = new Date().getTime(); // today unix
        if ((startUnix > dUnix) || (endUnix > dUnix)) {
            this.openHint(Common.ErrorCodeMap[Common.ErrorHintMap.DatePeriodError]);
            return false;
        }

        return true;
    }

    private async searchByCondition() {
        if (!this.validCondition()) {
            return false;
        }

        if (!Util.passReconciliationByCookie()) {
            return;
        }

        this.isLoading = true;

        // 整理input (有兩處使用item整理 => 匯出也需要整理條件)
        const item = TCBReceiptApi.Protobuf.ReimbursementQuery.create();
        item.storeList = this.searchItem.storeArr; // 特店清單 - 輸入"特店代號""
        item.tidNumber = this.searchItem.tidNumber;
        item.authCode = this.searchItem.approvalCode; // 授權碼
        item.cardNo = this.searchItem.cardNum; // 卡號
        item.cardType = this.searchItem.cardType.join(","); // 卡別
        item.type = this.searchItem.transactionType; // 交易別
        item.flag = this.searchItem.noteType; // 註記

        item.orderNo = this.searchItem.orderNum; // 訂單編號
        item.dateType = this.searchItem.type; // 日期區間
        item.dateStart = this.searchItem.start; // 起
        item.dateEnd = this.searchItem.end; // 訖
        item.terminalNoStart = this.searchItem.machineCodeStart; // 端末機號區間 起
        item.terminalNoEnd = this.searchItem.machineCodeEnd; // 端末機號區間 訖

        console.log("請款搜尋參數");
        console.log(item);

        /* 寫入 local storage 方便列印 */
        const storageItem: {
            filterType: string,
            search: TCBReceiptApi.Protobuf.ReimbursementQuery,
        } = {
            filterType: this.filterType,
            search: item,
        }
        localStorage.setItem("FrontReconciliationReimbursement", JSON.stringify(storageItem));
        /* 寫入 local storage 方便列印 */

        const reimbursementQuery = TCBReceiptApi.Protobuf.ReimbursementQuery.encode(item).finish();

        /* init */
        this.init();
        /* init */

        /* 取得總計 */
        await ReimbursementModel.getReimbursementTotal(reimbursementQuery);
        this.reimbursementTotal = ReimbursementModel.getReimbursementTotalObj();
        console.log('reimbursementTotal');
        console.log(this.reimbursementTotal);
        
        if (this.reimbursementTotal.count > process.env.VUE_APP_LIST_COUNT_LIMIT) { 
            // insert schedule_report
            const reportParams = TCBReceiptApi.Protobuf.ScheduleReportInfo.create();
            reportParams.type = 2;
            reportParams.fromWhere = ScheduleReport.WhereCode.Reimbursement;
            reportParams.params = JSON.stringify(item);
            reportParams.count = this.reimbursementTotal.count;

            const reportQuery = TCBReceiptApi.Protobuf.ScheduleReportInfo.encode(reportParams).finish();

            await ScheduleReportModel.add(reportQuery);

            this.isLoading = false;
            this.openHint(Common.ErrorCodeMap[Common.ErrorHintMap.ListCountExceed]);
            return false;
        }
        /* 取得總計 */

        /* 取得列表 */
        await ReimbursementModel.getReimbursement(reimbursementQuery);
        const reimbursementList = ReimbursementModel.getReimbursementList();

        this.reconciliationList = reimbursementList.list;
        console.log("回傳的特店列表 this.reconciliationList");
        console.log(this.reconciliationList);
        /* 取得列表 */

        /* 取得展開資料 - map */
        await ReimbursementModel.getReimbursementCollectionMap(reimbursementQuery);

        const reimbursementCollectionMap: TCBReceiptApi.Protobuf.ReimbursementCollectionMap = ReimbursementModel.getReimbursementCollectionMapData();
        console.log('第一次需要展開的資料');
        console.log("reimbursementCollectionMap");
        console.log(reimbursementCollectionMap);
        this.addTotalAndSubtotalFromMap(reimbursementCollectionMap.map);

        // 第一次預先展開
        this.unfoldList = [];
        Object.keys(reimbursementCollectionMap.map).forEach(
            (thisStoreCode) => {
                this.unfoldList.push(thisStoreCode);
            }
        );
        console.log("unfoldList");
        console.log(this.unfoldList);
        /* 取得展開資料 - map */

        /* 取得卡別彙總 */
        await ReimbursementModel.getReimbursementSummary(reimbursementQuery);
        this.reimbursementSummary = ReimbursementModel.getReimbursementSummaryData();
        console.log("reimbursementSummary卡別彙總");
        console.log(this.reimbursementSummary);
        /* 取得卡別彙總 */

        this.isLoading = false;
    }
    /* 搜尋 */

    /* filter => 明細, 依端末機彙總, 依結帳請款日彙總 */
    private async changeFilter(type: string) {
        this.filterType = type;

        /* 寫入 local storage 方便列印 */
        const reconciliationReimbursementJson = localStorage.getItem("FrontReconciliationReimbursement") as string;
        if (reconciliationReimbursementJson && reconciliationReimbursementJson !== "") {
            const reconciliationReimbursement = JSON.parse(reconciliationReimbursementJson) as { filterType: string, search: TCBReceiptApi.Protobuf.ReimbursementQuery };

            const storageItem: {
                filterType: string,
                search: TCBReceiptApi.Protobuf.ReimbursementQuery,
            } = {
                filterType: type,
                search: reconciliationReimbursement.search,
            }
            localStorage.setItem("FrontReconciliationReimbursement", JSON.stringify(storageItem));
        }
        /* 寫入 local storage 方便列印 */        
    }
    /* filter => 明細, 依端末機彙總, 依結帳請款日彙總 */

    /* 展開收合 */
    private checkIsUnfold(storeCode: string) {
        let isUnfold = false;
        this.unfoldList.some((thisStoreCode) => {
            if (thisStoreCode === storeCode) {
                isUnfold = true;
                return true;
            }
        });
        return isUnfold;
    }

    private async foldAndUnfoldItem(storeCode: string) {
        const isExist = this.unfoldList.findIndex(
            (thisStoreCode) => thisStoreCode === storeCode
        );

        if (isExist >= 0) {
            // 已經展開
            this.unfoldList.splice(isExist, 1);
        } else {
            // 判斷map是否有對應資料, 有 => 直接加入展開列表, 否 => 動態拿資料回來顯示
            if (!this.byTerminalNoMap[storeCode]) {
                // 整理input
                const item = TCBReceiptApi.Protobuf.ReimbursementQuery.create();
                item.authCode = this.searchItem.approvalCode; // 授權碼
                item.cardNo = this.searchItem.cardNum; // 卡號
                item.cardType = this.searchItem.cardType.join(","); // 卡別
                item.type = this.searchItem.transactionType; // 交易別
                item.flag = this.searchItem.noteType; // 註記

                item.orderNo = this.searchItem.orderNum; // 訂單編號
                item.dateType = this.searchItem.type; // 日期區間
                item.dateStart = this.searchItem.start; // 起
                item.dateEnd = this.searchItem.end; // 訖
                item.terminalNoStart = this.searchItem.machineCodeStart; // 端末機號區間 起
                item.terminalNoEnd = this.searchItem.machineCodeEnd; // 端末機號區間 訖
                item.specificStore = storeCode; // 單一特店

                const reimbursementQuery = TCBReceiptApi.Protobuf.ReimbursementQuery.encode(item).finish();

                /* 取得展開資料 */
                await ReimbursementModel.getReimbursementCollection(reimbursementQuery);
                const reimbursementCollection = ReimbursementModel.getReimbursementCollectionData();
                const reimbursementCollectionItem: { [k: string]: TCBReceiptApi.Protobuf.IReimbursementCollection } = {};
                // reimbursementCollectionItem[storeCode] = reimbursementCollection;
                this.$set(reimbursementCollectionItem, storeCode, reimbursementCollection);
                this.addTotalAndSubtotalFromMap(reimbursementCollectionItem);
                /* 取得展開資料 */
            }

            this.unfoldList.push(storeCode);
        }
    }
    /* 展開收合 */

    /* 展開明細 */
    private showAll(storeCode: string) {
        const isExist = this.showAllList.findIndex(
            (thisStoreCode) => thisStoreCode === storeCode
        );

        if (isExist >= 0) {
            this.showAllList.splice(isExist, 1);
        } else {
            this.showAllList.push(storeCode);
        }
    }

    private IsShowAllItem(storeCode: string) {
        const isExist = this.showAllList.findIndex(
            (thisStoreCode) => thisStoreCode === storeCode
        );

        return isExist >= 0;
    }
    /* 展開明細 */

    /* 查看批號明細 */
    private openTableLB(reconciliation: TCBReceiptApi.Protobuf.Reconciliation, byGroupTerminal: (TCBReceiptApi.Protobuf.ReimbursementInfo | GroupItem)) {
        const timeToKey = byGroupTerminal.date.split(" ")[0].split("/").join("") as string;
        const byGroupTerminalTableMapKey = reconciliation.storeCode + "_" + byGroupTerminal.terminalNo + "_" + timeToKey + "_" + byGroupTerminal.batchNo;  // 依端末機彙總索引key
                                     
        console.log("查看批號明細 openTableLB");
        console.log(reconciliation);
        console.log(byGroupTerminal);
        console.log("byGroupTerminalTableMapKey");
        console.log(byGroupTerminalTableMapKey);
        console.log(this.byGroupTerminalTableMap);

        this.tableType = 1; // 預設 1 => 請款, 2 => 撥款
        this.batchNoTitle = reconciliation as TCBReceiptApi.Protobuf.Reconciliation;
        this.batchNoInfo = this.byGroupTerminalTableMap[byGroupTerminalTableMapKey] as (TCBReceiptApi.Protobuf.ReimbursementInfo | GroupItem)[];

        this.isOpenTableLB = true;
    }

    private closeLBtable() {
        this.isOpenTableLB = false;
    }
    /* 查看批號明細 */

    /* 查看明細 */
    private openDetailLB(
        reconciliation: any,
        reimbursementInfo: TCBReceiptApi.Protobuf.ReimbursementInfo,
        type = 1 // 預設 1 => 請款, 2 => 撥款
    ) {
        this.detailTitle = reconciliation;
        this.detail = reimbursementInfo;
        this.detailType = type;

        this.isOpenDetailLB = true;
    }

    private closeLBdetail() {
        this.isOpenDetailLB = false;
    }
    /* 查看明細 */

    /* 其他 */
    private isNotNatureNum(val: string) {
        if (val) {
            const num = (val + "").replace(/,/g, "");
            return Number(num) <= 0;
        } else {
            return false;
        }
    }

    // 數字轉千分位 (number to string) ps.保留數字小數點至第二位
    private convertNumberToMoney(num: number) {
        if (!num) {
            return 0;
        }
        let a: string = (num + "").replace(/,/g, "");
        if (a.indexOf(".") != -1) {
            if (a.split(".")[1].length > 2) {
                a = Math.round(+a * 100) / 100 + "";
            }
            if (a.split(".").length == 2) {
                return (+a.split(".")[0]).toLocaleString() + "." + a.split(".")[1];
            } else {
                return (+a.split(".")[0]).toLocaleString();
            }
        } else {
            return (+a.split(".")[0]).toLocaleString();
        }
    }

    private addTotalAndSubtotalFromMap(storeCodeMap: { [k: string]: TCBReceiptApi.Protobuf.IReimbursementCollection; }) {
        if (storeCodeMap) {
            Object.keys(storeCodeMap).forEach(thisStoreCode => {
                // 明細 - 統計"特店合計""
                let storeCodeCountByDate = 0;
                let storeCodeSubtotalByDate = 0;

                const dateGroupNewInfoList: GroupItem[] = []; // 請款日彙總

                const dateMap = storeCodeMap[thisStoreCode].byDate as TCBReceiptApi.Protobuf.ReimbursementFirstMap;
                if (dateMap && dateMap.byFirstColumn) {
                    Object.keys(dateMap.byFirstColumn).forEach(thisDate => {
                        let dateSubtotal = 0; // 彙總 - 小計金額
                        let dateCount = 0; // 彙總 - 小計筆數

                        const terminalMap = dateMap.byFirstColumn[thisDate].bySecondColumn as { [k: string]: TCBReceiptApi.Protobuf.IReimbursementBatchNoMap };
                        if (terminalMap) {
                            Object.keys(terminalMap).forEach(thisTerminalNo => {
                                const batchNoMap = terminalMap[thisTerminalNo].byBatchNo as { [k: string]: TCBReceiptApi.Protobuf.Reimbursement };

                                if (batchNoMap) {
                                    Object.keys(batchNoMap).forEach(thisBatchNo => {
                                        const list = batchNoMap[thisBatchNo].list as TCBReceiptApi.Protobuf.ReimbursementInfo[];
                                        // 彙總 - Lb table
                                        const tableInfo: (TCBReceiptApi.Protobuf.ReimbursementInfo | GroupItem)[] = [];

                                        // 只統計該批號下的資料 批號小結
                                        const count = list.length;
                                        let subtotal = 0;
                                        let batchNo = "";

                                        list.forEach((thisInfo) => {
                                            if (thisInfo.infoType == 1) {
                                                // 彙總
                                                tableInfo.push(thisInfo);

                                                // 批號小結
                                                subtotal = subtotal + (thisInfo.amount as number);
                                                batchNo = thisInfo.batchNo as string; // 四碼
                                                // 每日小結
                                                dateCount = dateCount + 1;
                                                dateSubtotal = dateSubtotal + (thisInfo.amount as number);
                                                // 特店合計
                                                storeCodeCountByDate = storeCodeCountByDate + 1;
                                                storeCodeSubtotalByDate = storeCodeSubtotalByDate + (thisInfo.amount as number);
                                            }
                                        });

                                        // 依請款日彙總 - LB table - 批號小結
                                        const tableSubTotalItem: GroupItem =
                                        {
                                            terminalNo: "",
                                            date: "",
                                            batchNo: batchNo,
                                            count: count,
                                            amount: subtotal,
                                            infoType: 2, // 註記 = [1 => data, 2 => 批號小結]
                                        };
                                        tableInfo.push(tableSubTotalItem);

                                        // 依請款日彙總 - LB table
                                        this.$set(this.byGroupDateTableMap, thisBatchNo, tableInfo);

                                        // 依請款日彙總 - data
                                        const dateGroupItem: GroupItem =
                                        {
                                            terminalNo: thisTerminalNo,
                                            date: thisDate,
                                            batchNo: thisBatchNo,
                                            count: list.length,
                                            amount: subtotal,
                                            infoType: 1, // 註記 = [1 => data, 2 => 小計, 3 => 合計]
                                        };
                                        dateGroupNewInfoList.push(dateGroupItem);
                                    });
                                }
                            });
                        }

                        // 依請款日彙總 - 小計
                        if (dateGroupNewInfoList.length > 0) {
                            const dateGroupItem: GroupItem =
                            {
                                terminalNo: "",
                                date: "",
                                batchNo: "",
                                count: dateCount,
                                amount: dateSubtotal,
                                infoType: 2, // 註記 = [1 => data, 2 => 小計, 3 => 合計]
                            };
                            dateGroupNewInfoList.push(dateGroupItem);
                        }
                    });
                }

                // 依請款日彙總 - 合計
                const dateGroupItem: GroupItem =
                {
                    terminalNo: "",
                    date: "",
                    batchNo: "",
                    count: storeCodeCountByDate,
                    amount: storeCodeSubtotalByDate,
                    infoType: 3, // 註記 = [1 => data, 2 => 小計, 3 => 合計]
                };
                dateGroupNewInfoList.push(dateGroupItem);
                this.$set(this.byGroupDateMap, thisStoreCode, dateGroupNewInfoList);

                // ---------------------------------------------------------------------------------------------------------------------

                // 明細 - 統計"特店合計""
                let storeCodeCount = 0;
                let storeCodeSubtotal = 0;

                const terminalGroupNewInfoList: GroupItem[] = []; // 端末機彙總
                const terminalNewInfoList: TCBReceiptApi.Protobuf.IReimbursementInfo[] = []; // 明細 - 紀錄所有的資料 => (組好同一層直接v-for)

                const terminalMap = storeCodeMap[thisStoreCode].byTerminalNo as TCBReceiptApi.Protobuf.ReimbursementFirstMap;
                if (terminalMap && terminalMap.byFirstColumn) {
                    Object.keys(terminalMap.byFirstColumn).forEach(thisTerminalNo => {
                        const dateMap = terminalMap.byFirstColumn[thisTerminalNo].bySecondColumn as { [k: string]: TCBReceiptApi.Protobuf.IReimbursementBatchNoMap };
                        if (dateMap) {
                            // 明細 - 統計"端末機號小結""
                            let terminalCount = 0;
                            let terminalSubtotal = 0;

                            Object.keys(dateMap).forEach(thisDate => {
                                // 彙總 - 小計
                                // 明細 - 統計"每日小結""
                                let dateSubtotal = 0;
                                let dateCount = 0;

                                const batchNoMap = dateMap[thisDate].byBatchNo as { [k: string]: TCBReceiptApi.Protobuf.Reimbursement };
                                if (batchNoMap) {
                                    Object.keys(batchNoMap).forEach(thisBatchNo => {
                                        const list = batchNoMap[thisBatchNo].list as TCBReceiptApi.Protobuf.ReimbursementInfo[];

                                        // 彙總 - Lb table
                                        const tableInfo: (TCBReceiptApi.Protobuf.ReimbursementInfo | GroupItem)[] = [];

                                        // 明細 - 統計"批號小結""
                                        const count = list.length;
                                        let subtotal = 0;
                                        let batchNo = "";

                                        list.forEach((thisInfo) => {
                                            if (thisInfo.infoType == 1) {
                                                // 彙總
                                                tableInfo.push(thisInfo);

                                                // 明細
                                                terminalNewInfoList.push(thisInfo);
                                                // 批號小結
                                                subtotal = subtotal + (thisInfo.amount as number);
                                                batchNo = thisInfo.batchNo as string; // 四碼
                                                // 每日小結
                                                dateCount = dateCount + 1;
                                                dateSubtotal = dateSubtotal + (thisInfo.amount as number);
                                                // 端末機號小結
                                                terminalCount = terminalCount + 1;
                                                terminalSubtotal = terminalSubtotal + (thisInfo.amount as number);
                                                // 特店合計
                                                storeCodeCount = storeCodeCount + 1;
                                                storeCodeSubtotal = storeCodeSubtotal + (thisInfo.amount as number);
                                            }
                                        });

                                        // 依端末機彙總 - LB table - 批號小結
                                        const tableSubTotalItem: GroupItem =
                                        {
                                            terminalNo: "",
                                            date: "",
                                            batchNo: batchNo,
                                            count: count,
                                            amount: subtotal,
                                            infoType: 2, // 註記 = [1 => data, 2 => 批號小結]
                                        };
                                        tableInfo.push(tableSubTotalItem);

                                        // 依端末機彙總 - LB table
                                        // this.$set(this.byGroupTerminalTableMap, thisBatchNo, tableInfo);
                                        const timeToKey = thisDate.split(" ")[0].split("/").join("") as string;
                                        const byGroupTerminalTableMapKey = thisStoreCode + "_" + thisTerminalNo + "_" + timeToKey + "_" + thisBatchNo;  // 依端末機彙總索引key
                                        console.log("依端末機彙總索引key");
                                        console.log(byGroupTerminalTableMapKey);
                                        this.$set(this.byGroupTerminalTableMap, byGroupTerminalTableMapKey, tableInfo);

                                        // 依端末機彙總 - data
                                        const terminalGroupItem: GroupItem =
                                        {
                                            terminalNo: thisTerminalNo,
                                            date: thisDate,
                                            batchNo: thisBatchNo,
                                            count: list.length,
                                            amount: subtotal,
                                            infoType: 1, // 註記 = [1 => data, 2 => 小計, 3 => 合計]
                                        };
                                        terminalGroupNewInfoList.push(terminalGroupItem);

                                        // 明細 - 批號小結的小計(同批號)
                                        const subTotalItem: { itemName: string; infoType: number; amount: number; count: number; } =
                                        {
                                            itemName: batchNo, // 四碼
                                            infoType: 2, // 註記 = [1 => data, 2 => 批號小結的小計(同批號), 3 => 每日小結, 4 => 端末機號小結, 5 => 合計]
                                            amount: subtotal,
                                            count: count,
                                        };
                                        terminalNewInfoList.push(subTotalItem);
                                    });
                                }

                                // 依端末機彙總 - 小計
                                const terminalGroupItem: GroupItem =
                                {
                                    terminalNo: thisTerminalNo,
                                    date: thisDate,
                                    batchNo: "",
                                    count: dateCount,
                                    amount: dateSubtotal,
                                    infoType: 2, // 註記 = [1 => data, 2 => 小計, 3 => 合計]
                                };
                                terminalGroupNewInfoList.push(terminalGroupItem);

                                // 明細 - 每日小結
                                // 觀念 : 為了要讓每日小結與批號小結同層 在此無法使用push新增 而是對當前terminalNewInfoList列表最後一筆做編輯 額外設定每日小結
                                // 實作 : 直接使用arr.pop() 取得最後一組item且原先arr會被移除 再插入新整理好的item
                                const lastItem = terminalNewInfoList.pop() as { itemName: string; infoType: number; amount: number; count: number; };
                                if (lastItem) {
                                    const editItem: { itemName: string; infoType: number; amount: number; count: number; dateAmount: number } = {
                                        itemName: lastItem.itemName, // 四碼
                                        infoType: 3, // 註記 = [1 => data, 2 => 批號小結的小計(同批號), 3 => 每日小結, 4 => 端末機號小結, 5 => 合計]
                                        amount: lastItem.amount,
                                        count: lastItem.count,
                                        dateAmount: dateSubtotal,
                                    };
                                    terminalNewInfoList.push(editItem);
                                }
                            });

                            // 明細 - 端末機號小結
                            const subTotalItem: { itemName: string; infoType: number; amount: number; count: number; } =
                            {
                                itemName: thisTerminalNo,
                                infoType: 4, // 註記 = [1 => data, 2 => 批號小結的小計(同批號), 3 => 每日小結, 4 => 端末機號小結, 5 => 合計]
                                amount: terminalSubtotal,
                                count: terminalCount,
                            };
                            terminalNewInfoList.push(subTotalItem);
                        }
                    });
                }

                // 依端末機彙總 - 合計
                const terminalGroupItem: GroupItem =
                {
                    terminalNo: "",
                    date: "",
                    batchNo: "",
                    count: storeCodeCount,
                    amount: storeCodeSubtotal,
                    infoType: 3, // 註記 = [1 => data, 2 => 小計, 3 => 合計]
                };
                terminalGroupNewInfoList.push(terminalGroupItem);

                // 明細 - 合計
                const subTotalItem: { itemName: string; infoType: number; amount: number; count: number; } =
                {
                    itemName: thisStoreCode,
                    infoType: 5, // 註記 = [1 => data, 2 => 批號小結的小計(同批號), 3 => 每日小結, 4 => 端末機號小結, 5 => 合計]
                    amount: storeCodeSubtotal,
                    count: storeCodeCount,
                };
                terminalNewInfoList.push(subTotalItem);

                this.$set(this.byTerminalNoMap, thisStoreCode, terminalNewInfoList);

                this.$set(this.byGroupTerminalMap, thisStoreCode, terminalGroupNewInfoList);
            });
        }
    }
    /* 其他 */

    /* 特店清單LB */
    private openStoreLightbox() {
        this.isOpenStoreLB = true;
        this.$emit("searchStore", this.tidNumber);
    }
    /* 特店清單LB */

    /* 取得最新的權限map並判斷有何權限 */
    private async setPriv() {
        const meta = this.$route.meta as { privKey: { controller: string, method: string, type: string } };
        console.log(meta);

        const isSetPriv = await Priv._checkPriv(meta.privKey);
        if (!isSetPriv) {
            this.$router.push(DefaultPath);  // priv
        }

        if (!Priv._checkPrivType(meta.privKey.type)) {
            this.$router.push(DefaultPath);  // priv
        }

        this.expireTime = Priv._getExpireTime();
    }
    /* 取得最新的權限map並判斷有何權限 */

    private async exportFile() {
        if (!this.validCondition()) {
            return false;
        }

        if (!Util.passReconciliationByCookie()) {
            return;
        }

        this.isLoading = true;
        
        /* 報表專區 => 追加總計判斷 */
        if (this.filterType === 'detail') {
            // 整理input (有兩處使用item整理 => 匯出也需要整理條件)
            const item = TCBReceiptApi.Protobuf.ReimbursementQuery.create();
            item.storeList = this.searchItem.storeArr; // 特店清單 - 輸入"特店代號""
            item.tidNumber = this.searchItem.tidNumber;
            item.authCode = this.searchItem.approvalCode; // 授權碼
            item.cardNo = this.searchItem.cardNum; // 卡號
            item.cardType = this.searchItem.cardType.join(","); // 卡別
            item.type = this.searchItem.transactionType; // 交易別 => 1:購貨, 2:退貨
            item.flag = this.searchItem.noteType; // 註記

            item.orderNo = this.searchItem.orderNum; // 訂單編號
            item.dateType = this.searchItem.type; // 日期區間
            item.dateStart = this.searchItem.start; // 起
            item.dateEnd = this.searchItem.end; // 訖
            item.terminalNoStart = this.searchItem.machineCodeStart; // 端末機號區間 起
            item.terminalNoEnd = this.searchItem.machineCodeEnd; // 端末機號區間 訖

            console.log("請款搜尋參數");
            console.log(item);

            const reimbursementQuery = TCBReceiptApi.Protobuf.ReimbursementQuery.encode(item).finish();
            await ReimbursementModel.getReimbursementTotal(reimbursementQuery);
            const reimbursementTotal = ReimbursementModel.getReimbursementTotalObj();
            console.log('---------------');
            console.log(reimbursementTotal);
            console.log('---------------');
            /* 取得總計 */
            if (reimbursementTotal.count > process.env.VUE_APP_EXCEL_COUNT_LIMIT) { //
                // insert schedule_report
                const reportParams = TCBReceiptApi.Protobuf.ScheduleReportInfo.create();
                reportParams.type = 2;
                reportParams.fromWhere = ScheduleReport.WhereCode.Reimbursement;
                reportParams.params = JSON.stringify(item);
                reportParams.count = reimbursementTotal.count;

                const reportQuery = TCBReceiptApi.Protobuf.ScheduleReportInfo.encode(reportParams).finish();

                await ScheduleReportModel.add(reportQuery);

                this.isLoading = false;
                this.openHint(Common.ErrorCodeMap[Common.ErrorHintMap.ExcelCountExceed]); //
                return false;
            }
        }
        /* 報表專區 => 追加總計判斷 */

        // 整理condition (ReimbursementQuery)
        const queryArray: string[] = [];
        const storeArr: string[] = [];
        let idx = 0;

        for(let i=0; i<this.searchItem.storeArr.length; i++)
        {
            const storecodeTxt = this.searchItem.storeArr[i].substring(3, 11);

            idx = this.tidNumberArr.indexOf(storecodeTxt);
            if(idx == -1){
                storeArr.push(this.searchItem.storeArr[i]);
            }
        }

        const storeList: string = (storeArr.length !== 0) ? ("storeList=" + JSON.stringify(storeArr)) : "storeList=";
        queryArray.push(storeList);
        const tidNumber: string = (this.tidNumberArr.length !== 0) ? ("tidNumberList=" + JSON.stringify(this.tidNumberArr)) : "tidNumberList=";
        queryArray.push(tidNumber);

        if(storeArr.length > 50){
            this.openHint(Common.ErrorCodeMap[Common.ErrorHintMap.ExportNumExceedLimit]);
            this.isLoading = false;
            return false;
        }

        const authCode: string = (this.searchItem.approvalCode !== "") ? ("authCode=" + this.searchItem.approvalCode) : "authCode=";
        queryArray.push(authCode);
        const cardNo: string = (this.searchItem.cardNum !== "") ? ("cardNo=" + this.searchItem.cardNum) : "cardNo=";
        queryArray.push(cardNo);
        const cardType: string = (this.searchItem.cardType.length !== 0) ? ("cardType=" + this.searchItem.cardType.join(",")) : "cardType=";
        queryArray.push(cardType);
        const type: string = (this.searchItem.transactionType !== 0) ? ("type=" + this.searchItem.transactionType) : "type=";
        queryArray.push(type);
        const flag: string = (this.searchItem.noteType !== 0) ? ("flag=" + this.searchItem.noteType) : "flag=";
        queryArray.push(flag);

        const orderNo: string = (this.searchItem.orderNum !== "") ? ("orderNo=" + this.searchItem.orderNum) : "orderNo=";
        queryArray.push(orderNo);
        const dateType: string = (this.searchItem.type !== 0) ? ("dateType=" + this.searchItem.type) : "dateType=";
        queryArray.push(dateType);
        const dateStart: string = (this.searchItem.start !== "") ? ("dateStart=" + this.searchItem.start) : "dateStart=";
        queryArray.push(dateStart);
        const dateEnd: string = (this.searchItem.end !== "") ? ("dateEnd=" + this.searchItem.end) : "dateEnd=";
        queryArray.push(dateEnd);
        const terminalNoStart: string = (this.searchItem.machineCodeStart !== "") ? ("terminalNoStart=" + this.searchItem.machineCodeStart) : "terminalNoStart=";
        queryArray.push(terminalNoStart);
        const terminalNoEnd: string = (this.searchItem.machineCodeEnd !== "") ? ("terminalNoEnd=" + this.searchItem.machineCodeEnd) : "terminalNoEnd=";
        queryArray.push(terminalNoEnd);

        // tabType: { 1: "明細", 2: "端末機彙總", 3: "請款日彙總"}
        let tab = 0;
        switch (this.filterType) {
            case "detail":
                tab = 1;
                break;
            case "code":
                tab = 2;
                break;
            case "date":
                tab = 3;
                break;
        }
        const tabType: string = (tab !== 0) ? ("tabType=" + tab) : "tabType=";
        queryArray.push(tabType);

        console.log("queryArray");
        console.log(queryArray);
        const queryString = (queryArray.length === 0) ? "" : queryArray.join("&") as string;
        console.log("queryString");
        console.log(queryString);

        await ReimbursementModel.exportReimbursement(queryString);

        this.isLoading = false;
    }    

    private init() {
        this.byGroupDateTableMap = {};
        this.byGroupDateMap = {};
        this.byGroupTerminalTableMap = {};
        this.byTerminalNoMap = {};
        this.byGroupTerminalMap = {};
    }    
}
